import React from 'react';
import PropTypes from 'prop-types';
import classes from './tabs.module.scss';
import Checkbox from '../../../../_common/Form/Checkbox/Checkbox';
import InputField from '../../../../_common/Form/TextFields/InputField';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';

const ZenbexusFields = ({
  data, errors, changeData, disableFields, riskCategories
}) => {
  const selectCategory = (categoryPath, check) => {
    riskCategories.forEach(({ path }) => {
      changeData(path, path === categoryPath ? check : false);
    });
  };

  return (
    <>
      <div className={classes.zen_section}>
        <div className={classes.zen_header}>
          Patient Risk Categories
        </div>

        <div className={classes.zen_checkbox_group}>
          {riskCategories.map(({ path, label }) => (
            <Checkbox
              key={path}
              className={classes.zen_group_title}
              label={label}
              checked={!!data[path]}
              onChange={(check) => selectCategory(path, check)}
              readOnly={disableFields}
            />
          ))}
        </div>
      </div>

      <div className={classes.zen_section}>
        <div className={classes.zen_header}>
          Pharmacy Information
        </div>

        <div className={classes.zen_body}>
          <div className={classes.inputs_row}>
            <InputField
              label="Confirmation No."
              height={35}
              labelDefaultPosition={5}
              value={data.confirmationNo}
              onChange={(v) => changeData('confirmationNo', v)}
              error={errors.confirmationNo}
              disabled={disableFields}
            />

            <DOBPicker
              label="Confirmation Date"
              hideClearButton
              height={35}
              labelDefaultPosition={5}
              date={data.confirmationDate}
              wrapperClassName={classes.calendar_wrapper}
              dateFormat="YYYY-MM-DD"
              onChange={(d) => changeData('confirmationDate', d)}
              disabled={disableFields}
            />
          </div>
        </div>
      </div>
    </>
  );
};

ZenbexusFields.propTypes = {
  data: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  changeData: PropTypes.func.isRequired,
  disableFields: PropTypes.any,
};

export default ZenbexusFields;
